import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "feature-toggle",
  templateUrl: "feature-toggle.component.html",
})
export class FeatureToggleComponent implements OnInit {
  @Input() value: boolean;
  @Output() readonly onChange = new EventEmitter<boolean>();
  constructor() {}

  ngOnInit() {}

  emitChange() {
    this.value = !this.value;
    this.onChange.emit(this.value);
  }
}
